import { c as _c } from "react/compiler-runtime";
import LinkComponent, { LinkComponentLink } from '../link/link.component';
import { ReactElement, memo } from 'react';
import { CmsComponentContext } from '../container/CmsComponentContext';
import ConfigurableCmsComponentMetadata from '../../top-level-components/cms-page/metadata/configurable/configurable-cms-component-metadata.component';
import ConfigurableCmsValidity from '@spa/top-level-components/cms-page/metadata/configurable/configurable-cms-validity.component';
import HeadlineComponent from '../headline/headline.component';
import ImageComponent from '@spa/components/image-component/image.component';
import { Metadata } from '@spa/pages-converters/cms/component-envelops/CmsComponentEnvelopBase';
import styles from './service-teaser.component.module.scss';
interface Icon {
  readonly src: string;
  readonly alt: string;
  readonly width: number;
  readonly height: number;
  readonly mimeType: string;
}
export interface ServiceTeaser {
  readonly icon: Icon | null;
  readonly id: string;
  readonly link: LinkComponentLink | null;
  readonly metadata: ReadonlyArray<Metadata>;
  readonly headline: string | null;
  readonly benefits: ReadonlyArray<string>;
  readonly dateTo: number | null;
  readonly dateFrom: number | null;
}
export interface Props {
  readonly editorMode: boolean;
  readonly serviceTeaser: ServiceTeaser;
}
function ServiceTeaserComponent(t0) {
  const $ = _c(26);
  const {
    editorMode,
    serviceTeaser: t1
  } = t0;
  const {
    benefits,
    icon,
    id,
    link,
    metadata,
    headline,
    dateFrom,
    dateTo
  } = t1;
  let t2;
  if ($[0] !== icon) {
    t2 = icon && <ImageComponent className={styles["service-teaser__icon"]} src={icon.src} height={icon.height} width={icon.width} alt={`${icon.alt} icon`} mimeType={icon.mimeType} />;
    $[0] = icon;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== headline || $[3] !== id) {
    t3 = headline && <HeadlineComponent link={null} id={id} headline={headline} headlineTag="span" subHeadline={null} context={CmsComponentContext.FOOTER} />;
    $[2] = headline;
    $[3] = id;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== benefits) {
    t4 = benefits.length > 0 && <div className={styles["service-teaser__icon-bullets"]}><ul className={styles["service-teaser__benefits"]}>{benefits.map(_temp)}</ul></div>;
    $[5] = benefits;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2 || $[8] !== t3 || $[9] !== t4) {
    t5 = <div className={styles["service-teaser__linkable-content"]}>{t2}{t3}{t4}</div>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const linkableContent = t5;
  let t6;
  if ($[11] !== dateFrom || $[12] !== dateTo || $[13] !== editorMode || $[14] !== metadata) {
    t6 = editorMode && <><ConfigurableCmsComponentMetadata beforeComponent={true} metadata={metadata} /><ConfigurableCmsValidity dateFrom={dateFrom} dateTo={dateTo} /></>;
    $[11] = dateFrom;
    $[12] = dateTo;
    $[13] = editorMode;
    $[14] = metadata;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== link || $[17] !== linkableContent) {
    t7 = <div className={styles["service-teaser"]}><div className={`${styles["service-teaser__wrapper"]} h4`}>{link ? <div className={styles["service-teaser__link"]}><LinkComponent link={link}>{linkableContent}</LinkComponent></div> : linkableContent}</div></div>;
    $[16] = link;
    $[17] = linkableContent;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== editorMode || $[20] !== metadata) {
    t8 = editorMode && <ConfigurableCmsComponentMetadata beforeComponent={false} metadata={metadata} />;
    $[19] = editorMode;
    $[20] = metadata;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t6 || $[23] !== t7 || $[24] !== t8) {
    t9 = <div>{t6}{t7}{t8}</div>;
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  return t9;
}
function _temp(benefit) {
  return <li key={benefit} className={styles["service-teaser__benefit"]}>{benefit}</li>;
}
export default memo(ServiceTeaserComponent);